import { render, staticRenderFns } from "./PaymentOption.vue?vue&type=template&id=1828956d"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"
import style0 from "./PaymentOption.vue?vue&type=style&index=0&id=1828956d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports